import { Navbar, Logo } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { Ticker } from "@/components/landing/Ticker";
import { Why, Platform } from "@/components/landing/Features";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { Performance } from "@/components/landing/Performance";
import { Marketplace } from "@/components/landing/Marketplace";
import { Team } from "@/components/landing/Team";
import { Audience, Faq, FinalCta } from "@/components/landing/Closing";
import { useReveal } from "@/hooks/useReveal";
import { WhatsAppButton, WhatsAppLink } from "@/components/landing/WhatsApp";

export default function Landing() {
  useReveal();
  return (
    <div className="min-h-screen bg-[var(--tn-bg)] text-[var(--tn-text)]" data-testid="landing-page">
      <Navbar />
      <main id="main">
        <Hero />
        <Ticker />
        <Why />
        <Platform />
        <HowItWorks />
        <Performance />
        <Marketplace />
        <Team />
        <Audience />
        <Faq />
        <FinalCta />
      </main>
      <footer className="border-t border-[var(--tn-line)] py-10" data-testid="site-footer">
        <div className="max-w-[1152px] mx-auto px-5 md:px-8 grid md:grid-cols-[1fr_1.4fr_auto] gap-8 text-xs text-[var(--tn-muted)]">
          <div className="space-y-4">
            <Logo />
            <p className="max-w-sm">Illustrative figures only. Not investment advice. Past performance — backtested or live — does not guarantee future results. Derivatives trading carries a high risk of loss.</p>
          </div>
          <address className="not-italic text-sm leading-relaxed" data-testid="footer-address">
            <div className="tn-eyebrow mb-3">Contact</div>
            <p>Plot No. 22, Shallesh Co-Op Society,<br />Behind Kohinoor Lawn, Bhandewadi,<br />Wathoda, Nagpur 440008</p>
            <p className="mt-3 text-base font-semibold text-[var(--tn-text)]" data-testid="footer-contact-person">Contact Person : Nitesh C. Waghwani</p>
            <a href="mailto:support@tradingnifty.in" className="text-[var(--tn-cyan)] hover:underline mt-1 inline-block" data-testid="footer-email">support@tradingnifty.in</a>
            <div><WhatsAppLink /></div>
          </address>
          <p className="md:self-end">© {new Date().getFullYear()} Trading Nifty</p>
        </div>
      </footer>
      <WhatsAppButton />
    </div>
  );
}
